import { FilterOption } from '../../../components/_WMS/FilterComponent/types'

export const filterOptions: FilterOption[] = [
  { key: 'name', label: 'Nombre', type: 'text', order: 1 },
  { key: 'isActive', label: 'Activo', type: 'yesornotoption', order: 2 }
]
